export default [
    {
        path: 'kill',
        component: () => import('@/pages/isle/rank/kill')
    },
    {
        path: 'death',
        component: () => import('@/pages/isle/rank/death')
    },
    {
        path: 'online',
        component: () => import('@/pages/isle/rank/online')
    },
    {
        path: 'recharge',
        component: () => import('@/pages/isle/rank/recharge')
    },
    {
        path: 'repos',
        component: () => import('@/pages/isle/rank/repos')
    },
    {
        path: 'jifen',
        component: () => import('@/pages/isle/rank/jifen')
    },
    {
        path: 'longbi',
        component: () => import('@/pages/isle/rank/longbi')
    }
];



